import { useQuery } from '@apollo/client';
import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import { GetLatestComplianceMonitoringAssessmentTestResultsByControlIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { useGetLatestComplianceMonitoringAssessmentTestResultsByControlId as useGetLatestComplianceMonitoringAssessmentTestResultsByControlIdTRPC } from './useGetLatestComplianceMonitoringAssessmentTestResultsByControlIdTRPC';

export const useGetLatestComplianceMonitoringAssessmentTestResultsByControlId =
  (controlId: string, skip?: boolean) => {
    const trpcEnabled = useIsFeatureVisibleToOrg('trpc');
    const { addNotification } = useNotifications();

    const {
      data: graphqlData,
      loading: graphqlLoading,
      refetch: graphqlRefetch,
      error: graphqlError,
    } = useQuery(
      GetLatestComplianceMonitoringAssessmentTestResultsByControlIdDocument,
      {
        variables: {
          controlId: controlId,
        },
        fetchPolicy: 'no-cache',
        skip: trpcEnabled || skip, // Skip GraphQL query when TRPC is enabled
        onError: (error) => {
          if (!trpcEnabled) {
            addNotification({
              type: 'error',
              content: <>{error.message}</>,
            });
          }
        },
      }
    );

    const {
      data: trpcData,
      loading: trpcLoading,
      refetch: trpcRefetch,
      error: trpcError,
    } = useGetLatestComplianceMonitoringAssessmentTestResultsByControlIdTRPC(
      controlId,
      skip
    );

    // Return appropriate data based on feature flag
    if (trpcEnabled) {
      return {
        loading: trpcLoading,
        data: trpcData,
        refetch: () => trpcRefetch(),
        error: trpcError,
      };
    }

    return {
      loading: graphqlLoading,
      data: graphqlData,
      refetch: () => graphqlRefetch(),
      error: graphqlError,
    };
  };
